module.exports = __webpack_public_path__ + "static/media/letter_8@3x.3e2e7736.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/letter_8@3x.png
// module id = 600
// module chunks = 0